import Base from './Base'
import gsap from 'gsap'
import EmblaCarousel from 'embla-carousel'
import { evt, utils, store } from '@/core'

const { qs, qsa } = utils
const { dom, bounds } = store

export default class extends Base {
	onEnter() {
		super.onEnter()	
	}

	onLeave() {
		super.onLeave()
	}

	onEnterCompleted() {
		super.onEnterCompleted()

		const handlersubmenu = qsa('.filter-medios > li')
		handlersubmenu.forEach(sbli => {
			sbli.addEventListener('click', () =>{
				if(!sbli.classList.contains('open')){
					handlersubmenu.forEach(li => li.classList.remove('open'))
					sbli.classList.toggle('open')
				}else{
					handlersubmenu.forEach(li => li.classList.remove('open'))
				}
			})
		});
		//submenu
		/**/
		const filters = qsa('.sb-menu > li');

		filters.forEach(filter => { 

			filter.addEventListener('click', () => {

				let selectedFilter = filter.getAttribute('data-href');
				let itemsToHide = document.querySelectorAll(`.block-medios:not(.${selectedFilter})`);
				let itemsToShow = document.querySelectorAll(`.block-medios.${selectedFilter}`);

				if (selectedFilter == 'all') {
					itemsToHide = [];
					itemsToShow = document.querySelectorAll('.block-medios');
				}

				itemsToHide.forEach(el => {
					el.classList.add('hide');
					el.classList.remove('show');
				});

				itemsToShow.forEach(el => {
					el.classList.remove('hide');
					el.classList.add('show'); 
				});

			});
		});
	}

	onLeaveCompleted() {
		super.onLeaveCompleted()
	}
	
}